import axios from "axios";
import { getToken } from "./storage";

const rest = axios.create({
  responseType: "json",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

rest.interceptors.request.use(
  function (config) {
    const token = getToken();
    if (!config.headers.Authorization && token.length && config.headers["X-Auth"] !== "no-auth")
      config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default rest;
